import { render, staticRenderFns } from "./ModalCopecSyncHistory.vue?vue&type=template&id=64e5b4a8&scoped=true"
import script from "./ModalCopecSyncHistory.vue?vue&type=script&lang=js"
export * from "./ModalCopecSyncHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalCopecSyncHistory.vue?vue&type=style&index=0&id=64e5b4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5b4a8",
  null
  
)

export default component.exports